/// <amd-module name="Artifacts/FeedPicker/redux/Actions" />
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { ILoadFailedPayload } from "Artifacts/Root/redux";
import { IFeedIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction, trackedErrorAction } from "redux/Utils/ActionHelper";

export const enum FeedPickerActionTypes {
  LoadData = "Artifacts/FeedPicker/LoadData",
  LoadDataStarted = "Artifacts/FeedPicker/LoadDataStarted",
  LoadDataCompleted = "Artifacts/FeedPicker/LoadDataCompleted",
  LoadDataFailed = "Artifacts/FeedPicker/LoadDataFailed",
}

export interface ILoadCompletedPayload {
  feeds: IFeedIdentity[];
  deletedFeeds: IFeedIdentity[];
}

export const FeedPickerActions = {
  loadData: () => createAction(FeedPickerActionTypes.LoadData),
  loadStarted: () => createAction(FeedPickerActionTypes.LoadDataStarted),
  loadCompleted: (feeds: IFeedIdentity[], deletedFeeds: IFeedIdentity[]) =>
    createAction<FeedPickerActionTypes, ILoadCompletedPayload>(
      FeedPickerActionTypes.LoadDataCompleted,
      { feeds, deletedFeeds },
    ),
  loadFailed: (error: string) =>
    trackedErrorAction(
      createAction<FeedPickerActionTypes, ILoadFailedPayload>(
        FeedPickerActionTypes.LoadDataFailed,
        {
          error,
        },
      ),
    ),
};

export type FeedPickerActions = ActionsUnion<typeof FeedPickerActions>;
